import React from 'react';
import EmbeddedApp from '../../components/embeddedApp/embeddedApp';

const HelpdeskPage = () => (
  <EmbeddedApp
    audience="helpdesk"
    title="Helpdesk"
    buildIframeSrc={(code) => `https://helpdesk.mavistech.uk/sso?code=${code}`}
  />
);

export default HelpdeskPage;
